export type PublicViewerSession = {
  email: string;
  companyName: string;
  isVerifiedRecruiter: boolean;
  viewerType: string;
  identifiedAt: string;
};

const STORAGE_PREFIX = 'ss-public-viewer:';

function storageKey(username: string) {
  return `${STORAGE_PREFIX}${username.toLowerCase()}`;
}

export function readPublicViewerSession(
  username: string | null | undefined
): PublicViewerSession | null {
  if (!username || typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(storageKey(username));
    if (!raw) return null;
    return JSON.parse(raw) as PublicViewerSession;
  } catch {
    return null;
  }
}

export function writePublicViewerSession(
  username: string,
  session: Omit<PublicViewerSession, 'identifiedAt'> & {
    identifiedAt?: string;
  }
) {
  if (typeof window === 'undefined') return;
  const payload: PublicViewerSession = {
    ...session,
    identifiedAt: session.identifiedAt || new Date().toISOString(),
  };
  sessionStorage.setItem(storageKey(username), JSON.stringify(payload));
}

export function clearPublicViewerSession(username: string) {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(storageKey(username));
}
